import React from 'react';
import PlaneIcon from '../../assets/icons/plane-green.svg';
import '../../assets/styles/negative-advice.scss';
import config from '../../config';
import moment from 'moment';
import messages from '../../views/messages/searchFlightForm';
import { useIntl } from 'react-intl';

const locale = {
  en: 'en-gb',
  nl: 'nl',
  es: 'es',
  pl: 'pl',
  be: 'fr',
  fr: 'fr',
  it: 'it',
  de: 'de',
  da: 'da',
};

/* tslint:disable no-var-requires */
require(`moment/locale/${locale[config?.locale] || 'en-gb'}`);

interface FlightInfoInterface {
  data: {
    airline_code: string;
    departure_airport: string;
    arrival_airport: string;
    flight_code: string;
    flight_date: string;
  };
  description?: string;
}

const FlightInfo = (props: FlightInfoInterface) => {
  const { data, description } = props;
  const { formatMessage } = useIntl();

  return (
    <div
      className="negative-flight-container flex flex-col "
      style={{ gap: '12px' }}
    >
      <div className="flex items-center justify-between" style={{ gap: '8px' }}>
        <div>
          <span className="airport-text">{data?.departure_airport}</span>
        </div>
        <div className="border-dashed" />
        <img src={PlaneIcon} width={24} height={24} />
        <div className="border-dashed" />
        <div>
          <span className="airport-text">{data?.arrival_airport}</span>
        </div>
      </div>
      <div className="flex" style={{ gap: '12px' }}>
        <div className="flight-info-box">
          <span className="text">
            {formatMessage(messages.flightNumberLabel)}
          </span>
          &nbsp;
          <span className="text-data">{data?.flight_code}</span>
        </div>
        <div className="flight-info-box">
          <span className="text">
            {formatMessage(messages.flightDateLabel)}
          </span>
          &nbsp;
          <span className="text-data">
            {moment(data?.flight_date).format('DD/MM/YYYY')}
          </span>
        </div>
      </div>
      <div>
        <span className="negative-advice-text">{description}</span>
      </div>
    </div>
  );
};

export default FlightInfo;
